import * as React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  DeleteButton,
  TextInput,
  NumberField,
  NumberInput,
  BooleanField,
  BooleanInput,
  required,
  useTranslate,
} from "react-admin";

import EmptyList from "../components/misc/EmptyList";

const entity = "scripts";

export const ScriptList = (props) => {
  const translate = useTranslate();
  return (
    <List {...props} title={translate('scripts.title', { _: 'Kod ve Script Yönetimi' })} empty={<EmptyList entity={entity} />} exporter={false}>
      <Datagrid bulkActionButtons={false}>
        <TextField source="name" label={translate('scripts.name', { _: 'Script Adı' })} />
        <NumberField source="order" label={translate('scripts.order', { _: 'Sıra' })} />
        <BooleanField source="isActive" label={translate('scripts.active', { _: 'Aktif mi?' })} />
        <EditButton />
        <DeleteButton basePath={`/${entity}`} />
      </Datagrid>
    </List>
  );
};

export const ScriptEdit = (props) => {
  const translate = useTranslate();
  return (
    <Edit title={translate('scripts.edit_script', { _: 'Scripti Düzenle' })} {...props}>
      <SimpleForm redirect={`/${entity}`}>
        <TextInput source="name" label={translate('scripts.name', { _: 'Script Adı' })} fullWidth validate={required()} />
        <NumberInput source="order" label={translate('scripts.order', { _: 'Sıra' })} fullWidth defaultValue={0} />
        <BooleanInput source="isActive" label={translate('scripts.active', { _: 'Aktif mi?' })} defaultValue={true} />
        <TextInput
          source="content"
          label={translate('scripts.content', { _: 'Script Kodu' })}
          fullWidth
          multiline
          rows={12}
          validate={required()}
          helperText={translate('scripts.helper_text', { _: '<script> etiketleri dahil tüm script kodunu buraya yapıştırabilirsiniz.' })}
        />
      </SimpleForm>
    </Edit>
  );
};

export const ScriptCreate = (props) => {
  const translate = useTranslate();
  return (
    <Create title={translate('scripts.new_script', { _: 'Yeni Script Ekle' })} {...props}>
      <SimpleForm redirect={`/${entity}`}>
        <TextInput source="name" label={translate('scripts.name', { _: 'Script Adı' })} fullWidth validate={required()} />
        <NumberInput source="order" label={translate('scripts.order', { _: 'Sıra' })} fullWidth defaultValue={0} />
        <BooleanInput source="isActive" label={translate('scripts.active', { _: 'Aktif mi?' })} defaultValue={true} />
        <TextInput
          source="content"
          label={translate('scripts.content', { _: 'Script Kodu' })}
          fullWidth
          multiline
          rows={12}
          validate={required()}
          helperText={translate('scripts.helper_text', { _: '<script> etiketleri dahil tüm script kodunu buraya yapıştırabilirsiniz.' })}
        />
      </SimpleForm>
    </Create>
  );
};
